import * as React from "react"

const getUrl = (node) => {
    // Test if empty
    if (node.nodeUri) {
        return `/${node.nodeUri}`
    } else {
        return '#'
    }
}

const isBrowser = typeof window !== "undefined"

const activePath = () => {
    if (isBrowser) {
        return window.location.pathname.replace(/^\/|\/$/g, '')
    } else {
        return ""
    }
}

const isActive = (node) => {
    return activePath().includes(node.nodeUri)
}

const navWalker = (nodes, child = false) => {
    if (!nodes || nodes.length === 0) {
        return null
    }

    return nodes.map(node => (
        <span key={node.key}>
            {node.nodeUri != null && node.enabled === true &&
                <li className={`${node.remoteChildren && node.remoteChildren.length > 0 ? "menu-item-has-children" : ""} ${child === false ? "nav-item" : ""}`}>
                    <a className={`${child === false ? "nav-link" : ""} ${isActive(node) ? "active" : ""}`} href={getUrl(node)}>{node.title}</a>

                    {node.remoteChildren && node.remoteChildren.length > 0 &&
                        <ul className="sub-menu">{navWalker(node.remoteChildren, true)}</ul>
                    }

                </li>
            }
        </span>
    ))
}

const TopNavigation = (navigation) => {
    return navWalker(navigation)
}

const FooterNavigation = (navigation) => {
    return navigation.map(node => (
        <span key={node.key}>
            {node.typeLabel === "Passive"
                ? <h3 className="mb-0">{node.title}</h3>
                : <h6 className="text-decoration-underline"><a href={getUrl(node)}>{node.title}</a></h6>
            }
            <div className="page-links mt-2 mb-2">
                {node.remoteChildren && node.remoteChildren.length > 0 &&
                    node.remoteChildren.map(childNode => (
                        <div key={childNode.key}>
                            <a href={getUrl(childNode)}>{childNode.title}</a>
                        </div>
                    ))
                }
            </div>
        </span>
    ))
}

export {
    TopNavigation,
    FooterNavigation
}

